import styled from "styled-components";

import trending from "../../../../../images/thewire/trending.png";

const VideoWrapper = styled.div`
  margin-top: 30px;
  margin-bottom: 30px;
  .spacer {
    height: 20px;
  }
  .videoTitle {
    color: #f04f38;
    font-size: 18px;
    margin-bottom: 15px;
    line-height: 27px;

    a {
      color: #f04f38;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .videoDetail {
    font-weight: bold;
    width: 150px;
  }
  table tbody tr td {
    height: 25px;
    line-height: 25px;
  }
  .videoDesc p {
    margin-top: 25px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    height: 70px;
    span {
      line-height: 22px;
    }
  }

  .no-description p {
    margin-top: 0;
    height: auto !important;
    span {
      line-height: normal;
    }
  }
  .listLicenseBt {
    position: relative;
    height: 35px;
    button {
      background-color: ${(props) => props.theme.colors.primary.main};
      width: 255px;
      border-radius: 2px !important;
      transition: background-color 0.15s;
      font-weight: 400;
      &:hover {
        background-color: #e0331a;
        transition: background-color 0.15s;
      }
    }
  }
  .videoTrending::before {
    content: "";
    background-image: url(${trending});
    background-repeat: no-repeat;
    vertical-align: top;
    background-position: center top;
    position: absolute;
    width: 25px;
    height: 16px;
    top: 8px;
  }

  .listPlayer,
  .gridPlayer {
    position: relative;
  }
  .gridPlayer:hover .vjs-big-play-button,
  .listPlayer:hover .vjs-big-play-button {
    background-color: #f04d37;
  }

  .vjs-big-play-button {
    top: calc(50% - 34.5px);
    left: calc(50% - 34.5px);
    width: 69px;
    height: 69px;
    line-height: 69px;
    border: none;
    border-radius: 50%;
    font-size: 3.5em;
    background-color: rgba(0, 0, 0, 0.3);
    color: #fff;
    -webkit-transition: border-color 0.4s, outline 0.4s, background-color 0.4s;
    -moz-transition: border-color 0.4s, outline 0.4s, background-color 0.4s;
    -ms-transition: border-color 0.4s, outline 0.4s, background-color 0.4s;
    -o-transition: border-color 0.4s, outline 0.4s, background-color 0.4s;
    transition: border-color 0.4s, outline 0.4s, background-color 0.4s;
    position: absolute;

    &:hover {
      background-color: #f04d37;
    }

    &::before {
      content: "\f101";
      font-family: "VideoJS";
      font-weight: 400;
      font-style: normal;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  @media screen and (min-width: 768px) {
    .videoTitle {
      width: 98%;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
    .videoTrending::before {
      left: 300px;
    }
  }
  @media screen and (max-width: 767px) {
    margin-top: unset;
    .videoTitle {
      margin-top: 15px;
      line-height: 25px;
    }
    .listLicenseBt button {
      width: 230px;
    }
    .videoTrending::before {
      right: 0;
    }
  }

  @media screen and (min-width: 320px) and (max-width: 360px) {
    .listLicenseBt {
      button {
        width: 190px;
      }
    }
  }
`;

export default VideoWrapper;
